export const debounceTime = {
    none: 0,
    snappy: 30,
    standard: 300,
    delayed: 600,
};
//# sourceMappingURL=debounce.js.map